import { apiService } from './api.services.js'

export async function cashierApi(path, method = 'GET', payload) {
  const result = await apiService(`/api/cashier/${path}`, method, payload)
  if (!result || result.err || result.detail || result.error || result.status_code >= 400) {
    const error = new Error(result && (result.err || result.detail || result.error) || 'No pudimos cargar la caja. Intenta actualizar.')
    error.status = result && result.status_code
    throw error
  }
  return result
}

export async function downloadCashierTickets(registerId, sale) {
  // Refresh the session through the shared client before fetching the binary PDF.
  await cashierApi('registers/')
  const token = window.localStorage.getItem('organizer_access_token')
  const response = await fetch(`/api/cashier/registers/${registerId}/sales/${sale.id}/tickets/`, {
    credentials: 'same-origin', headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!response.ok) throw new Error('No pudimos descargar las entradas. Reintenta; la venta ya está cobrada.')
  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement('a')
  link.href = url
  link.download = `fomo-caja-${sale.invoice_id}.pdf`
  link.click()
  window.setTimeout(() => URL.revokeObjectURL(url), 30000)
}

export async function printCashierTickets(registerId, sale) {
  // Open during the user's click so mobile/desktop popup blockers allow printing.
  const paper = window.open('', '_blank')
  if (!paper) throw new Error('Permite abrir la ventana de impresión y vuelve a intentarlo.')
  paper.opener = null
  paper.document.title = 'Preparando entradas Fomo'
  paper.document.body.textContent = 'Preparando impresión…'
  try {
    await cashierApi('registers/')
    const token = window.localStorage.getItem('organizer_access_token')
    const response = await fetch(`/api/cashier/registers/${registerId}/sales/${sale.id}/print/`, {
      credentials: 'same-origin', headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    if (!response.ok || !(response.headers.get('content-type') || '').startsWith('text/html')) throw new Error('No pudimos preparar la impresión. La venta sigue cobrada.')
    const html = await response.text()
    if (paper.closed) return
    paper.document.open(); paper.document.write(html); paper.document.close()
    await Promise.all(Array.from(paper.document.images).map(img => img.complete ? Promise.resolve() : new Promise(resolve => { img.onload = resolve; img.onerror = resolve })))
    if (!paper.closed) { paper.focus(); paper.print() }
  } catch (error) { if (!paper.closed) paper.close(); throw error }
}
